import { IEntityTypeIdentifier } from "@rightship-tech/common-ui/models/basic.models";
import { LinkedIncidentModel, LinkedPscInspectionModel } from "../fbrs/fbr.models";
import { BaseValidationResponse } from "../validations/validations.models";
import { SubtaskCorrespondenceEmailModel } from "../vetting/vetting.models";

export enum CfrStatusEnum {
    New = 1,
    InProgress = 2,
    AwaitingResponse = 3,
    CfrReassignment = 4,
    Closed = 5,
    PendingReview = 6,
    Cancelled = 7
}

export interface NewCfrResponse extends BaseValidationResponse {
    cfrId: number;
}

export interface NewCfrRequest {
    cfrId?: number;
    vesselId: number;
    cfrCategoryId: number;
    title: string;
    description: string;
    cfrVettingCondition: number;
    attachments: File[];
    businessUnitId: number;
    expiryDate?: Date;
    comments?: string;
    fbrItemId?: number;
    attachmentsToCopy?: { entityAttachmentId: number, fileName: string }[];
}

export enum CfrVettingConditionEnum {
    FlagForCustomer = 1,
    FlagForAllVets = 2,
}

export interface CfrStatusHistoryClientModel {
    createdDate: Date;
    status: string;
    previousStatusId?: number;
    statusId: number;
    user: string;
    comment: string;
    fullComment: string;
    subtaskTypes: number[];
}

export interface CfrClientModel extends IEntityTypeIdentifier {
    description: string;
    expiryDate: Date;
    cfrVettingCondition: CfrVettingConditionEnum;
    customerId: number;
    businessUnitId: number;
    cfrCategoryId: number;
    cfrCategory: string;
    cfrId: number;
    vesselId: number;
    cfrStatusId: number;
    cfrStatus: string;
    yearOfConstruction?: number;
    dateRequested: Date;
    built?: Date;
    deadWeightTonnage: number;
    requestedBy: string;
    requestedByEmail?: string;
    phoneNumbers: string[];
    assignedUserId: number;
    assignedTo?: string;
    internationalMaritimeOrganizationNumber: string;
    vehicleIdentificationNumber: string;
    europeanNumberOfIdentification: string;
    vesselName: string;
    vesselType: string;
    comments: string;
    title: string;
    cfrStatusHistory: CfrStatusHistoryClientModel[];
    cfrCorrespondenceEmails?: SubtaskCorrespondenceEmailModel[];
    linkedIncidents?: LinkedIncidentModel[];
    linkedPscInspections?: LinkedPscInspectionModel[];
    requestedByBusinessUnitId?: number;
    requestedByBusinessUnit?: string;
    starRating: number;
    rating: string;
    reviewRequired: boolean;
    vetSuperLastModifiedName?: string;
    vetSuperLastModifiedDate?: Date;
    fbrItemId?: number;
    fbrId?: number;
    commentDateModified?: Date;
    flagForAllVets?: boolean;
    flagForCustomer?: boolean;
    flagForPort?: boolean;
    dontFlagForAnyVets?: boolean;
    documentsCount?: number;
    privateNotesCount?: number;
    correspondenceCount?: number;
}